// extracted by mini-css-extract-plugin
export default {"modal":"alert_modal__jXQ6J","mcontent":"alert_mcontent__k4ZKL","backbutton":"alert_backbutton__SmLfz"};